//
//
//
//
//
//
//
//

import api from '@/api'
import wx from 'weixin-js-sdk'
export default {
  props: {
    play: {
      video: '',
      videoid: ''
    }
  },
  data () {
    return {
      data: null,
      playid: ''
    }
  },
  mounted: function () {
  },
  methods: {
    players () {
      /* eslint-disable */
      var player = new Aliplayer({
        id: this.playid,
        source: this.play.video,
        cover: 'https://img01.wanfangche.com/public/video/201804/2018042401.jpg',
        vid: this.play.videoid,
        preload: true,
        controlBarVisibility: 'click',
        accessKeyId: this.data.AccessKeyId,
        accessKeySecret: this.data.AccessKeySecret,
        securityToken: this.data.SecurityToken,
        autoplay: true,
        useH5Prism: true,
        showBuffer: true,
        playsinline: false,
        skinLayout: [
          {
            "name": "bigPlayButton",
            "align": "cc"
            //"x": 30,
            //"y": 80
          },
          {
            "align": "blabs",
            "x": 0,
            "y": 0,
            "name": "controlBar",
            "children": [
              {
                "align": "tl",
                "x": 15,
                "y": 26,
                "name": "playButton"
              }, {
                "align": "tl",
                "x": 10,
                "y": 24,
                "name": "timeDisplay"
              }, {
                "align": "tr",
                "x": 20,
                "y": 25,
                "name": "fullScreenButton"
              }, {
                "align": "tr",
                "x": 20,
                "y": 25,
                "name": "volume"
              },
              {
                "name": "progress",
                "align": "tlabs",
                "x": 0,
                "y": 0
              }
            ]
          }]
      }, function (ply) {
      })
      /* eslint-enable */
      var _video = document.querySelector('video')
      player.on('play', function (e) {
        e.preventDefault = true
        e.stop
        _video.removeEventListener('click', play)
        _video.addEventListener('click', pause)
      })
      player.on('pause', function (e) {
        e.preventDefault = true
        e.stop
        _video.removeEventListener('click', pause)
        _video.addEventListener('click', play)
      })
      function play () {
        if (player) player.play()
      }
      function pause () {
        if (player) player.pause()
      }
    },
    btn () {
    },
    autoPlay () {
      var url = window.sessionStorage.getItem('initUrl') || window.location.href
      this.axios.post(api.rv.wxcode, {url: url})
      .then(response => {
        if (response.data.code === 200) {
          wx.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: 1,
            nonceStr: '',
            signature: '',
            jsApiList: []
          })
          wx.ready(function () {
            var div = document.getElementById(this.playid)
            var video = div.getElementsByTagName('video')[0]
            video.play()
          })
        }
      })
    }
  },
  created () {
    if (this.play) {
      this.playid = 'playid' + this.play.id
      this.axios.post(api.feed.videosdk)
      .then(response => {
        if (response.data.code === 200) {
          this.data = response.data.data.Credentials
          this.players()
          let _this = this
          setTimeout(function () {
            _this.autoPlay()
          }, 500)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/aliplay/index.vue